import Config from '@config';
import { PicSearchData, PicTypeRuleAirtable } from '@typings';
import Airtable from 'airtable';

import { mapRuleRecord, mapStateConfigRecord } from './airtableMappers';

// Created on first fetch, not at import: `new Airtable()` throws without an API key, so an
// import-time instance would take down any module that merely imports this one (a test, a story
// with the query cache pre-seeded) in an environment where the key is absent.
let base: Airtable.Base | undefined;
const getBase = (): Airtable.Base =>
    (base ??= new Airtable({ apiKey: Config.AIRTABLE_API_KEY }).base(Config.AIRTABLE_BASE_ID));

export const fetchPicSearchData = async (): Promise<PicSearchData[]> => {
    try {
        const base = getBase();
        const [pictypeRulesRecords, stateConfigRecords] = await Promise.all([
            base('Pictype_Rules')
                .select({
                    filterByFormula: '{Active} = TRUE()',
                    sort: [{ field: 'Priority', direction: 'asc' }],
                })
                .all(),
            base('State_Configuration')
                .select({
                    filterByFormula: '{Active} = TRUE()',
                    sort: [{ field: 'Priority', direction: 'asc' }],
                })
                .all(),
        ]);

        const rulesMap = new Map<string, PicTypeRuleAirtable>();
        pictypeRulesRecords.forEach((record) => {
            const rule = mapRuleRecord(record);
            if (rule) {
                rulesMap.set(record.id, rule); // use Airtable record.id
            }
        });

        return stateConfigRecords.map((record) => mapStateConfigRecord(record, rulesMap));
    } catch (error) {
        console.error('Airtable fetch error:', error);
        throw new Error(
            `Failed to fetch data from Airtable: ${error instanceof Error ? error.message : 'Unknown error'}`
        );
    }
};
